module.exports = __webpack_public_path__ + "static/media/salaam.fb0a1e69.jpg";